import React, { useState, useEffect } from "react"

import { Form } from "react-bootstrap"
import { getUser } from "@myaccountServices/store/utils"

import InputField from './elements/input'
import SelectField from './elements/select'
import TextAreaField from './elements/textarea'
import CheckboxField from './elements/checkbox'
import RadioField from './elements/radio'
import ButtonField from './elements/button'
import HtmlBox from './elements/html'
import ReCaptchaBox from './elements/recaptcha'
import AddressSearchRenting from './elements/address-search-renting'
import { postFormData } from "./api/Api"
import _ from "lodash";
import $ from 'jquery'

import axios from "axios"
import * as qs from "query-string"

function DownloadForm(props) {
  const userData = getUser();
  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showthankyou, setThankyou] = useState(false);
  const [addressPostalCode, setAddressPostalCode] = useState('')
  const [addressLabel, setAddressLabel] = useState('')

  const [formvalues, setFormvalues] = useState("");

  const [token, setToken] = useState("");

  const myRef = React.createRef();

  const recaptchaRef = React.createRef();

  const fields = ([
    {
      element: "config",
      formname: "Download Form",
      form_type: "contact",
      error_text: "Highlighted fields are required | invalid",
      success_text: "Thank you for contacting Martyn Gerrard. A member of our team will contact you shortly.",
      email_temp_user: "download_user",
      email_temp_admin: "download_admin",
      email_server_func: "download_form",
      event_tracking: "download_form",
      page_url: "/general-enquiry"
    },

    {
      grpmd: "12",
      label: "Name",
      placeholder: "Your Name *",
      name: "name",
      type: "text",
      element: "input",
      required: true,
      patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
      labelClass: "content_b-18",
      defaultValue: userData?.name || ``
    },
    {
      grpmd: "12",
      label: "Email",
      placeholder: "Your Email Address *",
      name: "email",
      type: "email",
      element: "input",
      required: true,
      patternchk: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      labelClass: "content_b-18",
      defaultValue: userData?.email || ``

    },
    {
      grpmd: "12",
      label: "Telephone",
      placeholder: "Your Telephone Number *",
      name: "telephone",
      type: "text",
      element: "input",
      required: true,
      patternchk: "^[+]*[0-9-()]+(\\s+[0-9-()]+)*.{9}$",
      labelClass: "content_b-18",
      defaultValue: userData?.mobile || ``

    },
    {
      grpmd: "12",
      label: "What's your property address?",
      placeholder: "Start typing your address *",
      name: "address",
      type: "text",
      element: "address",
      step: "stepone",
      required: true,
      patternchk: "^[-a-zA-Z0-9-()]+(\\s+[-a-zA-Z0-9-()]+)*$",
      labelClass: "content_b-18"
    },
    {
      grpmd: "12",
      label: "Message",
      placeholder: "Write your message here",
      name: "message",
      element: "textarea",
      class: "mb-4",
      rows: "2"
    },
    {
      grpmd: "12",
      name: "Download Now",
      type: "submit",
      element: "button",
      value: "submit",
      class: "btn",
      labelClass: "content_b-18"
    },
    {
      text: 'By clicking Submit, you agree to our <a href="/terms-and-conditions/"> Terms &amp; Conditions </a> and <a href="/privacy-policy/"> Privacy Policy </a>',
      element: "html",
      class: "terms modalterms"
    },
    {
      element: "captcha",
      class: "py-2 captcha-class",
      captchaRef: recaptchaRef
    }
  ]);

  const handlechange = event => {
    // remove initial empty spaces
    event.target.value = event.target.value.trimStart()
  }

  const downloadPDF = async (download_url, fileName) => {
    const pdfUrl = download_url; // your PDF URL


    try {
      const response = await fetch(pdfUrl, {
        method: "GET",
        mode: "cors", // important for cross-origin files
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url); // free memory
    } catch (error) {
      console.error("PDF download failed:", error);
    }
  };

  useEffect(() => {
    if (token !== '') {

      const processFromData = async () => {

        let formData = new FormData();

        formData.append('data', JSON.stringify(formvalues));

        postFormData(formData).then(apiRes => {
          downloadPDF(props.download_url, props.fileName)
          props.setOpenForm(false);
          // lets send mail
          const axiosOptions_email = {
            url: '/.netlify/functions/server/' + fields[0].email_server_func,
            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: qs.stringify(formvalues),
          }

          axios(axiosOptions_email)
            .then(response => {
              console.log('mail sent!')
            })
            .catch(err =>
              console.log(err)
            );
        });

        formvalues['g-recaptcha-response'] = token;


        const url = typeof window !== 'undefined' ? window.location.href : ''
        if (url.indexOf("property") > -1 && fields[4].event_tracking_decider) {
          fields[0].formname = 'Get mortgage help';
        }
        // tracking event
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'formSubmit',
          'formType': 'form-' + fields[0].event_tracking,
          'formId': 'form-' + fields[0].event_tracking,
          'formName': fields[0].formname,
          'formLabel': fields[0].formname
        });

        setShowerror(false);
        setThankyou(true);
        myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })

      }
      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    console.log("captcha verified");
    setToken(token);
  };

  const handleSubmit = event => {

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
    else {

      event.preventDefault();

      const formsdata = (event.target);
      const json = {}
      Object.keys(formsdata).map(key => (
        json[formsdata[key].name] = (formsdata[key].checked) ? 'yes' : formsdata[key].value
      ))

      json['email_temp_user'] = fields[0].email_temp_user;
      json['email_temp_admin'] = fields[0].email_temp_admin;
      json['formname'] = fields[0].formname;

      json['g-recaptcha-response'] = token;
      json['extra'] = _.omit(json, ["formname", "name", "email", "telephone"])

      setFormvalues(json);

      recaptchaRef.current.execute();

      setValidated(false);

      $('.book-a-viewing-form').hide();
      $('.form-extra').show();
      document.getElementById("form-extra-title").innerHTML = "Thank you for downloading Your Guide to The Renters' Rights Act. If there is anything we can help with please dont hesitate to get in touch.";
      // setTimeout(() => {
      //   props.setOpenForm(false);
      // }, 2000)
      // reset form
      const form = event.target
      form.reset();
    }
  };

  return (
    <>
      <div class="form-extra"><h1 id="form-extra-title"></h1></div>
      <div className="form stbform valuation-main book-a-viewing-form">
        <div className="form stbform">

          {showerror && <div className="alert-error">
            <p>{fields[0].error_text}</p>
          </div>}

          {showthankyou && <div className="alert-success">
            <p>{fields[0].success_text}</p>
          </div>}


          <Form className="contact-form" name={fields[0].formname} action="/thank-you/" method="post" noValidate validated={validated} onSubmit={handleSubmit}>
            <input type="hidden" name="form_name" value={fields[0].formname} />
            <input type="hidden" name="form_type" value={fields[0].form_type} />
            <input type="hidden" name="to_email_id" value={process.env.MAIL_TO_LL_COMMENTS} />
            <input type="hidden" name="contact_link" value={"/rentingischanging?source=contactform"} /> 
            <input type="hidden" name="bot-field" />
            <input type="hidden" name="filename" value={props.download_url} />
            <input type="hidden" name="file" value={props.fileName} />
            <input id="addressLabel" value="" type="hidden" name="addressLabel" />
            <input id="addressBuildingName" value="" type="hidden" name="addressBuildingName" />
            <input id="addressBuildingNumber" value="" type="hidden" name="addressBuildingNumber" />
            <input id="addressPostalCode" value={addressPostalCode} type="hidden" name="addressPostalCode" />

            <input id="addressSubBuilding" value="" type="hidden" name="addressSubBuilding" />
            <input id="addressStreet" value="" type="hidden" name="addressStreet" />
            
            <div className="step-block">
              {fields.map((field, index) => {
                if ("input" === field.element) {
                  return (
                    <InputField
                      name={field.name}
                      grpmd={field.grpmd}
                      ref={field.ref}
                      type={field.type}
                      fieldClass={field.class}
                      placeholder={field.placeholder}
                      labelClass={field.labelClass}
                      required={field.required}
                      key={`${field.element}~${index}`}
                      pattern={field.patternchk}
                      handlechange={handlechange}
                      defaultValue={field.defaultValue}
                    />
                  );
                }
                if ("select" === field.element) {
                  return (
                    <SelectField
                      name={field.name}
                      grpmd={field.grpmd}
                      ref={field.ref}
                      required={field.required}
                      fieldClass={field.class}
                      placeholder={field.placeholder}
                      values={field.values}
                      key={`${field.element}~${index}`}
                      handlechange={handlechange}
                      componentprops={props}
                    />
                  );
                }
                if ("textarea" === field.element) {
                  return (
                    <TextAreaField
                      name={field.name}
                      grpmd={field.grpmd}
                      ref={field.ref}
                      rows={field.rows}
                      fieldClass={field.class}
                      labelClass={field.labelClass}
                      placeholder={field.placeholder}
                      required={field.required}
                      key={`${field.element}~${index}`}
                      handlechange={handlechange}
                    />
                  );
                }
                if ("checkbox" === field.element) {
                  return (
                    <CheckboxField
                      name={field.name}
                      ref={field.ref}
                      value={field.value}
                      fieldClass={field.class}
                      placeholder={field.placeholder}
                      required={field.required}
                      key={`${field.name}~${index}`}
                      handlechange={handlechange}
                    />
                  );
                }
                 if ("address" === field.element) {
                  return (
                    <AddressSearchRenting addressLabel={addressLabel} />
                  );
                }
                if ("radio" === field.element) {
                  return (
                    <RadioField
                      name={field.name}
                      ref={field.ref}
                      value={field.value}
                      fieldClass={field.class}
                      checked={field.checked}
                      placeholder={field.placeholder}
                      required={field.required}
                      key={`${field.name}~${index}`}
                      handlechange={handlechange}
                      lastchild={field.lastchild}
                    />
                  );
                }
                if ("html" === field.element) {
                  return (
                    <HtmlBox
                      text={field.text}
                      fieldClass={field.class}
                      key={`${field.element}~${index}`}
                    />
                  );
                }
                if ("captcha" === field.element) {
                  return (
                    <ReCaptchaBox
                      fieldClass={field.class}
                      captRef={field.captchaRef}
                      key={`${field.element}~${index}`}
                      handleonVerify={handleonVerify}
                    />
                  );
                }
                if ("button" === field.element) {
                  return (
                    <ButtonField
                      name={field.name}
                      fieldClass={field.class}
                      type={field.type}
                      value={field.value}
                      key={`${field.element}~${index}`}
                    />
                  );
                }
              })
              }
              <div ref={myRef} />
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}


const DownloadPDFForm = (props) => (
  <DownloadForm download_url={props.download_url} fileName={props.fileName} setOpenForm={props.setOpenForm} />
)

export default DownloadPDFForm
